/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateComponentTwinsGroupRequestDto
 */
export interface CreateComponentTwinsGroupRequestDto {
    /**
     * 
     * @type {string}
     * @memberof CreateComponentTwinsGroupRequestDto
     */
    groupName: string;
    /**
     * At least two ComponentSchema ids on the same asset
     * @type {Array<string>}
     * @memberof CreateComponentTwinsGroupRequestDto
     */
    componentTwinsIds: Array<string>;
}

/**
 * Check if a given object implements the CreateComponentTwinsGroupRequestDto interface.
 */
export function instanceOfCreateComponentTwinsGroupRequestDto(value: object): value is CreateComponentTwinsGroupRequestDto {
    if (!('groupName' in value) || value['groupName'] === undefined) return false;
    if (!('componentTwinsIds' in value) || value['componentTwinsIds'] === undefined) return false;
    return true;
}

export function CreateComponentTwinsGroupRequestDtoFromJSON(json: any): CreateComponentTwinsGroupRequestDto {
    return CreateComponentTwinsGroupRequestDtoFromJSONTyped(json, false);
}

export function CreateComponentTwinsGroupRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateComponentTwinsGroupRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'groupName': json['groupName'],
        'componentTwinsIds': json['componentTwinsIds'],
    };
}

export function CreateComponentTwinsGroupRequestDtoToJSON(json: any): CreateComponentTwinsGroupRequestDto {
    return CreateComponentTwinsGroupRequestDtoToJSONTyped(json, false);
}

export function CreateComponentTwinsGroupRequestDtoToJSONTyped(value?: CreateComponentTwinsGroupRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'groupName': value['groupName'],
        'componentTwinsIds': value['componentTwinsIds'],
    };
}

